import React from "react";
import { EcpSourceDataIssuesTable } from "../entities/ecp/ecp-sourceDataIssue-entity";

export function EcpSourceDataIssuesPage(props) {
  return <EcpSourceDataIssuesTable {...props} />;
}
